// Format currency utility with USD as default
export const formatCurrency = (amount: string | number) => {
  // Convert string amount to number
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;

  // Handle NaN and invalid values
  if (isNaN(num)) return '$0.00';

  // Format as USD currency
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};
